import AuthRepository from '@/api/repositories/AuthRepository';
import UserRepository from '@/api/repositories/UserRepository';
import TaxiRepository from '@/api/repositories/TaxiRepository';
import DriverRepository from '@/api/repositories/DriverRepository';
import CompanyRepository from '@/api/repositories/CompanyRepository';
import RideRepository from '@/api/repositories/RideRepository';
import DashboardRepository from '@/api/repositories/DashboardRepository';
import BillingRepository from '@/api/repositories/BillingRepository';
import TransactionRepository from '@/api/repositories/TransactionRepository';
import ShareRepository from '@/api/repositories/ShareRepository';
import ManagerRepository from '@/api/repositories/ManagerRepository';
import StatisticsRepository from '@/api/repositories/StatisticsRepository';
import AnnouncementRepository from '@/api/repositories/AnnouncementRepository';
import PromoterRepository from '@/api/repositories/PromoterRepository';
import SmsRepository from '@/api/repositories/SmsRepository';
import FavoriteRepository from '@/api/repositories/FavoriteRepository';
import UploadRepository from '@/api/repositories/UploadRepository';
import FileRepository from '@/api/repositories/FileRepository';
import InvoiceRepository from '@/api/repositories/InvoiceRepository';
import RatingRepository from '@/api/repositories/RatingRepository';
import CustomerRepository from '@/api/repositories/CustomerRepository';
import ActivityLogRepository from '@/api/repositories/ActivityLogRepository';

const repositories: any = {
    auth: { Repository: AuthRepository, instance: null },
    company: { Repository: CompanyRepository, instance: null },
    driver: { Repository: DriverRepository, instance: null },
    taxi: { Repository: TaxiRepository, instance: null },
    user: { Repository: UserRepository, instance: null },
    ride: { Repository: RideRepository, instance: null },
    dashboard: { Repository: DashboardRepository, instance: null },
    billing: { Repository: BillingRepository, instance: null },
    transactions: { Repository: TransactionRepository, instance: null },
    share: { Repository: ShareRepository, instance: null },
    manager: { Repository: ManagerRepository, instance: null },
    statistics: { Repository: StatisticsRepository, instance: null },
    announcement: { Repository: AnnouncementRepository, instance: null },
    promoter: { Repository: PromoterRepository, instance: null },
    sms: { Repository: SmsRepository, instance: null },
    favorite: { Repository: FavoriteRepository, instance: null },
    upload: { Repository: UploadRepository, instance: null },
    file: { Repository: FileRepository, instance: null },
    invoice: { Repository: InvoiceRepository, instance: null },
    rating: { Repository: RatingRepository, instance: null },
    customer: { Repository: CustomerRepository, instance: null },
    activityLog: { Repository: ActivityLogRepository, instance: null }
};
/**
 *  Factory to create repositories. All created repositories are singleton instances.
 */
export const RepositoryFactory = {
    get: (name: string) => {
        if (repositories[name].instance) {
            return repositories[name].instance;
        } else {
            return new repositories[name].Repository();
        }
    }
};
